
import api from './api'

export const userLogin = params => {
  return api.post(`/CloudParkAPI/Home/Login`, params)
}
export const userThirdLogin = params => {
  return api.post(`/CloudParkAPI/Home/UserThirdLogin`, params)
}
export const otherLogin = (params) => {
  return api.post(`/CloudParkAPI/Home/OtherLogin`, params)
}
export const userLoginOut = params => {
  return api.post(`/CloudParkAPI/Home/LoginOut`, params)
}

export const getGroupInfo = params => {
  return api.post(`/CloudParkAPI/User/GetGroupInfo`, params)
}

export const getGroupByParent = params => {
  return api.post(`/CloudParkAPI/User/GetGroupByParent`, params)
}

export const editRootGroup = params => {
  return api.post(`/CloudParkAPI/User/EditRootGroup`, params)
}

export const deleteRootGroup = params => {
  return api.post(`/CloudParkAPI/User/DeleteRootGroup`, params)
}

export const editGroup = params => {
  return api.post(`/CloudParkAPI/User/EditGroup`, params)
}

export const getGroupPersAndPark = params => {
  return api.post(`/CloudParkAPI/User/GetGroupPersAndPark`, params)
}

export const editUser = params => {
  return api.post(`/CloudParkAPI/User/EditUser`, params)
}

export const deleteUser = params => {
  return api.post(`/CloudParkAPI/User/DeleteUser`, params)
}

export const getUserByGroupId = params => {
  return api.post(`/CloudParkAPI/User/GetUserByGroupId`, params)
}
export const getPerAndParkByParent = params => {
  return api.post(`/CloudParkAPI/User/GetPerAndParkByParent`, params)
}
export const getCurrentUserPerAndParkByGroup = params => {
  return api.post(`/CloudParkAPI/User/GetCurrentUserPerAndParkByGroup`, params)
}
export const getCurrentUser = params => {
  return api.post(`/CloudParkAPI/User/GetCurrentUser`, params)
}
export const editCurrentUserPwd = params => {
  return api.post(`/CloudParkAPI/User/EditCurrentUserPwd`, params)
}
export const getAllPers = params => {
  return api.post(`/CloudParkAPI/User/GetAllPers`, params)
}
export const getCurrentUserPers = (params) => {
  return api.post(`/CloudParkAPI/User/GetCurrentUserPers`, params)
}
export const resetUserPwd = (id) => {
  return api.get(`/CloudParkAPI/User/ResetUserPwd/${id}`)
}
export const getCurrentUserStatisticalData = (params) => {
  return api.post(`/CloudParkAPI/User/GetCurrentUserStatisticalData`)
}
export const validateCode = params => {
  return api.get(`/CloudParkAPI/Home/ValidateCode`, params)
}
export const initConfig = params => {
  return api.get(`/CloudParkAPI/Home/InitConfig`, params)
}
export const getEtcErrorCount = (params) => {
  return api.post(`/CloudParkAPI/Report/GetEtcErrorCount`)
}
export const getUserInfo = (id) => {
  return api.get(`/CloudParkAPI/User/GetUserInfo/${id}`)
}
export const tokenHeaderValue = () => {
  return api.get(`/CloudParkAPI/Home/TokenHeaderValue`)
}
export const getGroupNode = () => {
  return api.get(`/CloudParkAPI/User/GetGroupNode`)
}
export const getGroupByNode = (params) => {
  return api.post(`/CloudParkAPI/User/GetGroupByNode`, params)
}
export const getPermission = (params) => {
  return api.post(`/CloudParkAPI/User/GetPermission`, params)
}
export const getGroupCust = (params) => {
  return api.post(`/CloudParkAPI/User/GetGroupCust`, params)
}
export const saveGroup = (params) => {
  return api.post(`/CloudParkAPI/User/saveGroup`, params)
}
export const deleteUserGroup = (id) => {
  return api.get(`/CloudParkAPI/User/DeleteUserGroup/${id}`)
}
export const baiyueAuthtication = () => {
  return api.get(`/CloudParkAPI/User/BaiYueAuthtication`)
}



// WEBPACK FOOTER //
// ./src/api/user.js